export const chunkArray = <T>(arr: T[], chunkSize: number) => {
  const res = [];

  for (let i = 0; i < arr.length; i += chunkSize) {
    res.push(arr.slice(i, i + chunkSize));
  }

  return res;
};

export const capitalize = (text: string, capitalizeDelimited: boolean = true): string => {
  if (!text) return text;

  if (capitalizeDelimited) {
    // Split by common delimiters and capitalize each part
    return text
      .split(/([_\-\s]+)/)
      .map((part, index) => {
        // Keep delimiters as-is
        if (/[_\-\s]+/.test(part)) {
          return part;
        }
        // Capitalize words
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      })
      .join('');
  }

  // Default: only capitalize the first character
  return text.charAt(0).toUpperCase() + text.slice(1);
};
